import React, { useRef, useState } from 'react'
import Modal from '../../common/modal/Modal'
import ResponseMessage from '../../common/modal/ResponseMessage'
import ProcessingCSV from './ProcessingCSV'
import MicroModal from 'micromodal'
import { performRequest } from '../../common/utils'
import TableCsvMapping from './TableCsvMapping'
import AddSeats from './AddSeats'
import { HandleShowCloseModal } from '../../common/modal/HandleShowCloseModal'

const UploadCSV = ( props ) => {
    const team = JSON.parse( props['data-team'] )
    const [ inputFile, setInputFile ] = useState()
    const [ responseMessage, setResponseMessage ] = useState()
    const [ uploadCsvResponse, setUploadCsvResponse ] = useState()
    const [ mapCsvResponse, setMapCsvResponse ] = useState()
    const [ tableData, setTableData ] = useState()
    const [ importOptions, setImportOptions ] = useState({
        ignoreUsersIfMember: false,
        importOption: team.import_option
    })
    const fileInputRef = useRef(null)
    const seatBtn = team.is_admin ? "Grant More Seats" : "Buy More Seats"
    const canUseTeamIdOption = team.is_admin
    const [isLoading, setIsLoading] = useState({
        uploadingCSV: false,
        importingCSV: false
    })

    MicroModal.init()

    const inputFileChange = (e) => {
        setResponseMessage()
        const csvData = e.target.files[0] ?? {}
        const csvExtension = csvData['name'] ? csvData['name'].split('.').pop() : false

        if( csvData && csvExtension !== 'csv'){
            setResponseMessage({
                type: 'error',
                message: 'Invalid file extension'
            })
            resetFileInput()
            return
        }

        setInputFile( csvData )
    }

    const resetFileInput = () => {
        fileInputRef.current.value = ''
        setInputFile()
        setUploadCsvResponse()
        setMapCsvResponse()
        MicroModal.close('msync-modal-processing-import')
    }

    const checkImportOption = ( action ) => {
        setImportOptions(prevState => ({
            ...prevState,
            importOption: action
        }))
    }

    const checkHandlerIgnoreUsers = () =>{
        setImportOptions(prevState => ({
            ...prevState,
            ignoreUsersIfMember: !prevState.ignoreUsersIfMember
        }))
    }

    const uploadCsv = async () => {
        if( !inputFile ){
            setResponseMessage({
                type: 'error',
                message: 'File cannot be empty'
            })
            return
        }

        if( uploadCsvResponse ){
            setResponseMessage({
                type: 'error',
                message: 'Cannot re-upload same file'
            })
            return
        }

        if( team.subscription_status ){
            const subscriptionStatus = team.subscription_status

            if( (['cancelled', 'expired']).includes( subscriptionStatus ) ){
                setResponseMessage({
                    type: 'error',
                    message: 'Team subscription has been cancelled or expired'
                })
                return
            }
        }

        try {
            setIsLoading(prevState => ({
                ...prevState,
                uploadingCSV: true
            }))

            const formData = new FormData()
            formData.append('action', msyncCsvImport.create)
            formData.append('csv', inputFile)
            formData.append('nonce', msyncCsvImport.nonce_create)
            formData.append('team_id', team.team_id)
            formData.append('ignore_existing', importOptions.ignoreUsersIfMember ? true : "" )
            formData.append('import_option', importOptions.importOption ?? 'automatic' )
            
            const request = await performRequest( msyncCsvImport.url, formData )
            const res = await request.json()
            const isAllowedToImport = team.team_remaining_seat >= res.rowcount || team.team_seat_count === null
            if( !res.success ){
                throw new Error( res.errors.shift() )
            }

            setUploadCsvResponse({...res, isAllowedToImport})
            setNewTanstackData(res)

        } catch (error) {
            setResponseMessage({
                type:'error',
                message: error.message
            })
        } finally{
            setIsLoading(prevState => ({
                ...prevState,
                uploadingCSV: false
            }))
        }
    }

    const importAction = async() => {
        setResponseMessage()

        if( !uploadCsvResponse ){
            setResponseMessage({
                type: 'error',
                message: 'Cannot import without uploading the CSV!'
            })
            return
        }

        try {
            setIsLoading(prevState => ({
                ...prevState,
                importingCSV: true
            }))

            const formData = new FormData()
                
            const dataMapped = tableData.reduce((acc, data) => {
                if( data.selected === "" ) return acc
                acc[data.selected] = data.csvHeader
                return acc
            }, {})

            const checkEmailKeyExist = Object.keys( dataMapped ).includes('email')
        
            if( !checkEmailKeyExist ) {
                throw new Error( 'Email selection is required' )
            }

            formData.append('action', msyncCsvImport.map)
            formData.append('uid', uploadCsvResponse.uid)
            formData.append('nonce', msyncCsvImport.nonce_map)
            formData.append('map', JSON.stringify( dataMapped ) )

            const request = await performRequest( msyncCsvImport.url, formData )
            const res = await request.json()

            if( !res.success ){
                throw new Error( res.errors.shift() )
            }

            setMapCsvResponse(res)

            HandleShowCloseModal('msync-modal-processing-import', 'msync-upload-csv-modal')
        } catch (error) {
            setResponseMessage({
                type:'error',
                message: error.message
            })
        }
        finally{
            setIsLoading(prevState => ({
                ...prevState,
                importingCSV: false
            }))
        }

    }

    const setNewTanstackData = ( response ) => {
        
        const newData = Object.keys(response.row).map((res, i) => {
            // Find the best match using regex
            const selected = team.csv_headers.find((header) => {
                const regex = new RegExp(header.replace(/_/g, "\\s*"), "i");
                return (
                    res.replace(/_/g, " ").match(regex) ||
                    header
                    .replace(/_/g, "\\s*")
                    .match(new RegExp(res.replace(/_/g, "\\s*"), "i"))
                )
            }) || ""
    
            return {
                csvHeader: res,
                value: Object.values(response.row)[i],
                selected: selected
            }
        })

        return setTableData(newData)
    }

    const handleAddSeatBtn = () => {
        HandleShowCloseModal('msync-modal-add-seats', 'msync-upload-csv-modal')
    }

    return (
        <>
            <Modal modalId="msync-upload-csv-modal" buttonTitle="Upload Team Members(CSV)" >
                <header className="msync-modal__header">
                    <h2 className="msync-modal__title">Add Multiple Members (CSV Upload)</h2>
                    <button type="button" className="msync-button msync-modal__close" aria-label="Close modal" onClick={()=>MicroModal.close('msync-upload-csv-modal')} ><svg class="msync-icon msync-icon--exit" fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="m12 12.9-6.5 6.6-1-1 6.5-6.7-6.1-6.3 1-1 6.1 6.2 6-6.2 1.1 1-6 6.3 6.4 6.7-1 1L12 13Z" fill="currentcolor"/></svg></button>
                </header>
                <main className="msync-modal__content msync-upload-csv">
                { responseMessage && <ResponseMessage response={ responseMessage } /> }
                    <div className="msync-modal-upload-container msync-col">
                        <span>Upload CSV</span>
                        <div className="msync-modal-upload-container msync-row msync-between">
                            <input ref={fileInputRef} type="file" className="msync-file-input"
                            onChange={(e) => inputFileChange(e)}
                            onClick={(e) => resetFileInput()} 
                            />
                            <button type="button" className="msync-button msync-button-md msync-filled-primary-button" onClick={uploadCsv} disabled={isLoading.uploadingCSV}>
                                { isLoading.uploadingCSV ? 'Uploading...' : 'Upload File' }
                            </button>
                        </div>
                        { uploadCsvResponse && (
                                <>
                                    <div className="msync-modal-upload-container msync-col msync-to-import mt-5">
                                        {/* 
                                            as of now, no integrity check on the back-end so I commented it for now.
                                        <div className="msync-modal-upload-container msync-row msync-between">
                                            <strong>CSV Integrity Check</strong>
                                        </div>
                                        <div className="msync-message-csv">
                                            <p className='msync-message-response-success-text'>File has no errors</p>
                                        </div> */}
                                        <div className="msync-modal-upload-container msync-row msync-between">
                                            <strong>Seat Status</strong>
                                        </div>
                                        <div className="msync-modal-upload-container msync-row msync-between">
                                            <p className={`msync-seat-status ${ !uploadCsvResponse.isAllowedToImport && 'msync-error' }`}>
                                                { uploadCsvResponse.rowcount } rows to import / { team.team_seat_count === null ? 'unlimited seat' : `${team.team_remaining_seat} available seats`}</p>
                                            { !uploadCsvResponse.isAllowedToImport && (
                                                <button type="button" className='msync-button msync-button-md msync-outline-primary-button' onClick={ handleAddSeatBtn } >{seatBtn}</button>
                                            )}
                                        </div>
                                    </div>
                                    
                                    <TableCsvMapping tableData={tableData} setTableData={setTableData} canManage={canUseTeamIdOption} team={team} />
                                </>
                        )}
                        <div className='msync-modal-upload-container msync-col'>
                            {/* No back-end support for this as of now 
                            <label htmlFor="">No header exists</label>
                            <input type="checkbox" id="msync-no-header-exist" />  */}
                            {
                                !uploadCsvResponse && (
                                    <>
                                      {
                                        team.is_admin &&
                                        <div className='msync-modal-upload-container msync-col'>
                                          <strong>MEMBERS IMPORT BEHAVIOR</strong>
                                          <div className="msync-modal-import-behavior msync-row">
                                            <input type="radio" id="automatically_add_uploaded_users" value="automatic"  name="csv_import_option" onChange={()=>checkImportOption('automatic')} checked={importOptions.importOption === 'automatic'} />
                                            <label for="automatically_add_uploaded_users">Automatically add uploaded users</label>
                                            <span class="msync-sm-mx"></span>
                                            <input type="radio" id="invite_uploaded_users" value="invite" name="csv_import_option" onChange={()=>checkImportOption('invite')} checked={importOptions.importOption === 'invite'} />
                                            <label for="invite_uploaded_users">Invite uploaded users</label>
                                          </div>
                                        </div>
                                      }
                                      <div className="msync-modal-upload-container msync-row">
                                        <input type="checkbox" id="msync-ignore-users" style={{ margin: "0" }} onChange={checkHandlerIgnoreUsers} />
                                        <label htmlFor="msync-ignore-users">Ignore users who are already members</label>
                                      </div>
                                    </>
                                )
                            }
                          
                        </div>
                        <div className='msync-modal-upload-container msync-row msync-download-template'>
                            <p>Download <a href={`${team['csv_sample']}`} target="_blank" download={`${team['csv_file_name']}`}>template CSV</a></p>
                        </div>
                    </div>
                </main>
                <footer className='msync-modal__footer'>
                    { uploadCsvResponse && (
                        uploadCsvResponse.isAllowedToImport && (
                            <button type="button"
                            className="msync-button msync-button-md msync-filled-primary-button msync-to-import"
                            onClick={importAction}
                            disabled={isLoading.importingCSV}
                            >
                                { isLoading.importingCSV ? 'Importing...' : 'Import' }
                            </button>
                        )
                    )}
                </footer>
            </Modal>
            {<>
                <Modal modalId="msync-modal-processing-import" buttonTitle="">
                    <ProcessingCSV team={team} uploadCsvResponse={uploadCsvResponse} mapCsvResponse={mapCsvResponse} resetFileInput={resetFileInput} />
                </Modal>
                <Modal modalId="msync-modal-add-seats" buttonTitle="" classNames=""> 
                    <AddSeats team={team} />
                </Modal>
            </>}
        </>
    )
}

export default UploadCSV
